import ApiService from '@services/api.service';
import { Notify } from 'quasar';

export const user = {
  state: {
    users: [],
  },
  mutations: {
    setUsers(state, users) {
      state.users = users
    },
    setUser(state, user) {
      // Ajouter ou mettre à jour un utilisateur spécifique
      const index = state.users.findIndex(u => u.id === user.id);
      if (index !== -1) {
        state.users.splice(index, 1, user);
      } else {
        state.users.push(user);
      }
    },
    removeUser(state, userId) {
      // Supprimer un utilisateur du state (soft delete)
      const index = state.users.findIndex(u => u.id === userId);
      if (index !== -1) {
        state.users.splice(index, 1);
      }
    },
  },
  actions: {
    async fetchUsers({ commit }, params = { suspendre: 0, 'deleted_at[exist]': false }) {
      try {
        if(params['deleted_at[exists]'] === undefined) {
          params['deleted_at[exists]'] = 'false';
          {
            const response = await ApiService.getRequest('users', params);
            commit('setUsers', response.data['hydra:member']);
            return response.data['hydra:member'];
          }
        }
      } catch (error) {
        console.error("Erreur lors de la récupération des utilisateurs:", error);
        // Notify can be added here if needed
        throw error;
      }
    },
    fetchOneUser(context, url) {
      return ApiService.getRequest(url).then(
        response => {
          context.commit('setUser', response.data)
        }
      )
      .catch( error => { console.error(error) } );
    },
    fetchAntenneUsers(context, antenneId) {
      return ApiService.getRequest(`users?antenne=${antenneId}`).then(
        response => {
          context.commit('setUsers', response.data['hydra:member'])
        }
      )
        .catch( error => { console.error(error) } );
    }
  },
  getters: {
    getUsers(state) {
      return state.users;
    },
    getUserById: (state) => (id) => {
      return state.users.find(user => user.id === id);
    }
  }
}
